export default class MathHelper {
  public static getPercentageAmount(total: number, percentage: number) {
    return (percentage / 100) * total;
  }
}
